import { Stack } from 'expo-router';
import { PatientContextProvider } from '@/components/Contexts/PatientContext';

const StackLayout = () => {
  return (
    <PatientContextProvider>
      <Stack
        screenOptions={{
          headerShown: false,
        }}
      />
    </PatientContextProvider>
  );
};

export default StackLayout;
